import { Easing, type WithTimingConfig } from "@-/com.npmjs.react-native-reanimated";

/** How long the cards take to leave for the map, or to come back from it. */
export const LEARN_MAP_TRANSITION_DURATION_MS = 500;

/**
 * The cards' and the map's shared timing. The cards travel the whole screen height, so the curve
 * eases in as well as out: a sheet's front-loaded curve covered most of that distance in the first
 * frame or two, which read as a jump rather than a slide.
 */
export function learnMapTransition(): WithTimingConfig {
  return { duration: LEARN_MAP_TRANSITION_DURATION_MS, easing: Easing.bezier(0.4, 0, 0.2, 1) };
}
